export function initParallax(selector) {
    const textParallax = document.querySelectorAll(selector);
    const {height: headerHeight} = document.querySelector('header').getBoundingClientRect();

    textParallax.forEach(item => {
        const isVariant = item.hasAttribute('data-variant');
        if (isVariant) {
            item.parentElement.style.height = item.parentElement.getBoundingClientRect().height + 'px';

            item.classList.add('fixed');

            return true;
        }

        window.addEventListener('scroll', () => {
            const coordinates = item.getBoundingClientRect();
            if (0 < item.parentElement.getBoundingClientRect().y) {
                item.classList.remove('fixed');
                return true;
            }

            if ((headerHeight - 40) >= coordinates.top && coordinates.y <= 0) {
                item.parentElement.style.height = item.parentElement.getBoundingClientRect().height + 'px';
                let heightChildren = 0;
                Array.from(item.children).forEach(child => {
                    heightChildren += child.getBoundingClientRect().height;
                });
                const {height: footerHeight} = document.querySelector('#footerBar').getBoundingClientRect();
                const {height: headerHeight} = document.querySelector('header').getBoundingClientRect();
                const passePartoutHeight = window.innerHeight - (headerHeight + footerHeight) + 40;

                const offset = passePartoutHeight > heightChildren ? headerHeight : coordinates.top;
                item.style.top = offset + 'px';
                item.classList.add('fixed');
            }
            return true;
        });
    });

}

export const simpleParallax = (element) => {
    window.addEventListener('scroll', () => {
        const {top} = element.getBoundingClientRect();
        element.style.setProperty('--simple-parallax', `${top * -1}px`);
    });
};

function isInViewport(el, headerHeight) {
    const rect = el.getBoundingClientRect();

    return (rect.top <= window.innerHeight) && rect.bottom >= headerHeight;
}